export default __webpack_public_path__ + "static/media/fpsideimage.da54e988.svg";